import React from "react";
import * as styles from "./sidebar-user-menu.module.scss";
import SidebarUserMenuButton from "./sidebar-user-menu-button";
import { makeStyleable } from "../../helper/icon-helper";
import IconSettings from "../../dynamicicons/icon-settings";
import IconHelp from "../../dynamicicons/icon-help";
import IconLogOut from "../../dynamicicons/icon-log-out";

export interface SidebarUserMenuProps {
	name: string;
	organization: string;
	onOpenSettings?: VoidFunction;
	onOpenSupport?: VoidFunction;
	onLogOut?: VoidFunction;
}

export default function SidebarUserMenu(props: SidebarUserMenuProps) {
	return (
		<div className={styles.container}>
			<p className={styles.username}>{props.name}</p>
			<p className={styles.organization}>{props.organization}</p>

			<div className={styles.divider}></div>

			<SidebarUserMenuButton
				icon={makeStyleable(IconSettings)}
				label="Settings"
				onClick={props.onOpenSettings}
			/>

			<SidebarUserMenuButton
				icon={makeStyleable(IconHelp)}
				label="Support"
				onClick={props.onOpenSupport}
			/>

			<div className={styles.divider}></div>

			<SidebarUserMenuButton
				icon={makeStyleable(IconLogOut)}
				label="Log out"
				onClick={props.onLogOut}
			/>
		</div>
	);
}
